import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Radix UI popovers trigger a benign "ResizeObserver loop" browser error when
// they measure trigger width on open/close. Patch ResizeObserver to defer
// callbacks to the next animation frame — this prevents the loop condition
// from occurring in the first place so the browser never fires the error.
if (typeof window.ResizeObserver !== "undefined") {
    const _NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _NativeResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => callback(entries, observer));
            });
        }
    };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
